import {gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import {utilities} from "@/scripts/common/utilities"
import {YoutubeApi} from "./YouTube"
import {VimeoApi} from "./Vimeo"
import {addScrollController, ScrollControllers} from "@/scripts/common/api/scrolltrigger.services"
gsap.registerPlugin(ScrollTrigger)


export const Video = (() => {

    class VideoBanner {
        constructor(container, options) {
            this.$videoContainer = container
            this.$videoNative = this.$videoContainer.querySelector('.bg-vid')
            this.$videoIframe = this.$videoContainer.querySelector('.bg-iframe')
            this.$videoPlayer = this.$videoContainer.querySelector('.bg-vid__player')
            this.$videoControls = this.$videoContainer.querySelector('.bg-vid__controls')
            this.$videoPlayBtn = this.$videoContainer.querySelector('.bg-vid__controls-play')
            this.$videoMuteBtn = this.$videoContainer.querySelector('.bg-vid__controls-mute') 
            this.$articleElems = gsap.utils.toArray(this.$videoContainer.querySelectorAll('.article-generic > *'))
            this.videoPlaying = false
            this.videoType = this.$videoContainer.dataset.videoType || 'native'
            if(this.videoType === 'html5') this.videoType = 'native'
            this.playerReady = false
            this.Player = null
            this.controlRevealTimeoutFunc = null
            this.mainTl = null
            this.controlRevealTime = 5000
            this.scrollController = null
            
            this.options = Object.assign({
                fitIframe: true,
                background: this.$videoContainer.dataset.background === "1",
                autoplay: this.$videoContainer.dataset.autoplay === "1"  || this.$videoNative?.autoplay || false,
                loop: this.$videoContainer.dataset.loop === "1",
                onViewDemand: this.$videoContainer.dataset.onDemand || "1" 
            },
            {
                ...options
            })

            console.log(this.options)

            this.scrollOptions = {
                trigger: this.$videoContainer,
                start: 'top bottom',
                onToggle: self => {
                    if(this.options.background) {
                        !self.isActive ? this._pauseVideo() : this._playVideo()
                        return
                    }
                    if(!self.isActive) this._pauseVideo()
                }
            }
            this.init()
        }

        init() {
            this.makeAnim()
            this.makePlayer()
            this.$videoContainer.getVideo = () => this
        }

        // Iframe size
        makeIframeFit() {
            utilities.resizePlayer(this.$videoContainer)
        }

        // Iframe utilities
        toIframePlayer(player, command){
            if (player == null || command == null || player.contentWindow == null) return
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

        // Making player
        async makePlayer() {
            switch(this.videoType) {
                case 'youtube':
                    this.Player = await this.ytLoader()
                    this.playerReady = true
                    if(this.options.fitIframe) this.makeIframeFit()
                    this.updateUI()
                    this.addingListener()
                    break
                case 'vimeo':
                    this.Player = await this.vmLoader()
                    this.playerReady = true
                    this.updateUI()
                    this.addingListener()
                    if(this.options.fitIframe) this.makeIframeFit()
                    break
                default:
                    this.Player = this.$videoNative
                    this.playerReady = true
                    this.updateUI()
                    this.addingListener()
                    if(this.options.autoplay) this._playVideo()
            }
        }

        ytLoader() {
            return new Promise((resolve, reject) => {
                const player = new YoutubeApi.YtPlayer(this.$videoContainer, this.$videoPlayer, this.options)
                player.addEventListener('loaded', () => {
                    resolve(player)
                })
            })
        }

        vmLoader() {
            return new Promise((resolve, reject) => {
                const player = new VimeoApi.Player(this.$videoContainer, this.$videoPlayer, this.options)
                player.addEventListener('loaded', () => {
                    resolve(player)
                })
            })
        }

        _playVideo() {
            if(!this.Player) return
            this.videoPlaying = true
            this.Player?.play()
        }

        _pauseVideo() {
            if(!this.Player) return
            this.videoPlaying = false
            this.Player?.pause()
        }

        _muteToggle() {
            this.Player.muted = !this.Player.muted
        }

        // Animation
        makeAnim() {
            this.mainTl = gsap.timeline({paused: true})
            if(this.$videoPlayBtn)
                this.mainTl.to(this.$videoPlayBtn, {
                    duration: 0.4,
                    scale: 1.2,
                    ease: 'power2.inOut',
                    autoAlpha: 0
                })
           if(this.$articleElems.length && !this.$videoContainer.classList.contains("banner-dont-hide-content-on-play")) {
               this.mainTl.to(this.$articleElems, {
                   stagger: -0.05,
                   y: 50,
                   autoAlpha: 0,
                   ease: 'power2.inOut',
                   display: 'none'
               }, 0)
           } 
        }

        // Controls
        toggleVideo(e) {
            if(this.$videoMuteBtn && (this.$videoMuteBtn.contains(e.target) || e.target === this.$videoMuteBtn)) {
                this._muteToggle()
                return
            }
            this.videoPlaying ? this._pauseVideo() : this._playVideo()
        }

        // UI updates
        updateUI() {
            this.playingUIUpdate()
            this.mutedUIUpdate()
        }

        playingUIUpdate() {
            if(this.videoPlaying) {
                this.$videoContainer.classList.add('playing')
                this.$videoContainer.classList.remove('paused')
                this.mainTl?.play()
                return
            } 
            this.$videoContainer.classList.remove('playing')
            this.$videoContainer.classList.add('paused')
            this.mainTl?.reverse()
        }

        mutedUIUpdate() {
            if(this.Player.muted) {
                this.$videoContainer.classList.add('muted')
                return
            } 
            this.$videoContainer.classList.remove('muted')
        }

        // Callbacks
        updatePlay(play) {
            this.videoPlaying = play
            this.updateUI()
        }   

        // endScreenUpdate() {
        //     if(this.videoType === 'vimeo' && !this.options.loop) {
        //         this.Player?.seek(0)
        //         this.Player.play()
        //     }
        // }

        // Resize Callbacks
        resizeFunc() {
            return utilities.debounce(() => {
                if(this.options.fitIframe) this.makeIframeFit()
            }, 250)
        }

        addingListener() {
            this.$videoControls?.addEventListener('click', (e) => this.toggleVideo(e))
            this.Player?.addEventListener('play', () => this.updatePlay(true))
            this.Player?.addEventListener('pause', () => this.updatePlay(false))
            this.Player?.addEventListener('ended', () => this.updatePlay(false))
            this.Player?.addEventListener('volumechange', () => this.updateUI())
            //if(this.videoType === "vimeo") this.Player?.addEventListener('ended', () => this.endScreenUpdate())
            if(parseInt(this.options.onViewDemand) === "1") {
                this.scrollController = ScrollTrigger.create(this.scrollOptions)
                addScrollController(this.scrollController)
            }

            window.addEventListener('resize', this.resizeFunc())
        }
    }

    return {
        VideoBanner
    }
})()

export default Video